export default function mapLinear(val, a1, a2, b1, b2) {
  return b1 + ((val - a1) * (b2 - b1)) / (a2 - a1);
}
